import React, { useEffect } from "react";
import { FormikProps } from "formik";
import { User, Project } from "senf-shared/types";
import DemographicsForm from "../../../templates/demographics/DemographicsForm";
import { fetchProjectSpecificData } from "../../../../util/demographicUtils";

interface SurveyDemographicsProps {
  demographicsFormik: FormikProps<User>;
  project: Project;
  user: User;
}

const SurveyDemographics: React.FC<SurveyDemographicsProps> = ({
  demographicsFormik,
  project,
  user,
}) => {
  useEffect(() => {
    const loadProjectSpecificData = async () => {
      const participantData = await fetchProjectSpecificData(project, user);
      if (participantData) {
        demographicsFormik.setValues((prevValues) => ({
          ...prevValues,
          ...participantData,
        }));
      }
    };

    loadProjectSpecificData();
  }, [project, user]);

  return (
    <DemographicsForm
      formik={demographicsFormik}
      project={project}
      user={user}
      isAuthFlow={false}
    />
  );
};

export default SurveyDemographics;
